import React, { PureComponent } from 'react';
import { Navigate } from 'react-router-dom';
import { connect } from 'react-redux';
/*import { FormattedMessage } from 'react-intl';*/
import Settings from '../components/Settings'
import { CloakUtilService } from 'cloak-file-sdk-web'

class SettingsPage extends PureComponent {

    constructor(props){
        super(props)
        this.state = {
        }
    }

    componentDidMount() {
      console.log("In SettingsPage componentDidMount")
      CloakUtilService().checkInactivityLogout(this.props)
    }

    render() {
        const { token } = this.props;

        if ( !token ) {
            return <Navigate to="/cloak/login"/>;
        }

        return (
            <div>
                <Settings />
            </div>
        );
    }
}


const mapStateToProps = state => {
    return {
    token: state.auth.token
  }
};

export default connect(mapStateToProps)(SettingsPage);
